import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { TextField } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';

import validate from '../validate';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
};

let WizardFormFifthPage = (props) => {
  const { handleSubmit, previousPage } = props;

  const isGuarantor = props.initialValues.is_guarantor;

  let header = `${getTranslatedString('tenantPortal.application.personalBio.prompt.header')}`;
  let additionalDetails = `${getTranslatedString(
    'tenantPortal.application.personalBio.additionalDetails'
  )}`;
  if (isGuarantor) {
    header = `${getTranslatedString('tenantPortal.application.personalBio.guarantor.header')}`;
    additionalDetails = `${getTranslatedString(
      'tenantPortal.application.personalBio.guarantor.details'
    )}`;
  }

  return (
    <div id="top" style={{ marginTop: '50px' }}>
      <h3
        style={{
          fontSize: '30px',
          marginBottom: '10px',
          fontFamily: 'Circular-Bold',
        }}
      >
        {header}
      </h3>
      <form onSubmit={handleSubmit}>
        {!isGuarantor && (
          <div className="row">
            <h4> {getTranslatedString('tenantPortal.application.personalBio.moving')} </h4>
            <Field
              name="reason_for_moving"
              component={TextField}
              hintText={getTranslatedString('tenantPortal.application.personalBio.moving')}
              multiLine
              fullWidth
              style={{ fontSize: '15px', marginBottom: '20px' }}
              errorStyle={{ fontSize: '14px' }}
            />
          </div>
        )}
        <div className="row">
          <h4> {additionalDetails} </h4>
          <Field
            name="bio"
            component={TextField}
            hintText={getTranslatedString('tenantPortal.application.personalBio.details')}
            multiLine
            fullWidth
            style={{ fontSize: '15px', marginBottom: '60px' }}
            errorStyle={{ fontSize: '14px' }}
          />
        </div>
        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label={getTranslatedString('tenantPortal.application.personalBio.button.back')}
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
            <FlatButton
              label={getTranslatedString('tenantPortal.application.personalBio.button.next')}
              type="submit"
              className="next"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

WizardFormFifthPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardFormFifthPage);

WizardFormFifthPage = connect((state) => ({
  initialValues: state.tenantApplication.tenantApplication,
}))(WizardFormFifthPage);

export default WizardFormFifthPage;
